/* eslint-disable no-use-before-define */
import Types from './Types';
import { requestXrefByVenueXids } from './xrefActions';

const newsIdMap = {
	morningNewsId: 3118,
	weekAheadNewsId: 3070,
	usMorningNewsId: 3119
};

const receiveMarketNews = (response, xrefResults = false) => {
	const actions = [{
		type: Types.API_RECEIVE_MARKET_NEWS,
		response
	}];

	if (xrefResults
		&& response
		&& response.data
		&& response.data.items
		&& response.data.items.length > 0) {
		const newsItems = response.data.items;
		const xids = [];

		newsItems.forEach(item => {
			const { WSODIssue } = item;

			if (WSODIssue && WSODIssue.length > 0) {
				const issues = WSODIssue.split('|');

				if (issues && issues.length > 0) {
					issues.forEach(issue => {
						if (issue && issue !== '' && xids.indexOf(issue) === -1) {
							xids.push(issue);
						}
					});
				}
			}
		});

		if (xids.length > 0) {
			actions.push(requestXrefByVenueXids(xids));
		}
	}

	return actions;
};

const receiveEtfNews = (response, xrefResults = false) => {
	const actions = [{
		type: Types.API_RECEIVE_ETF_NEWS,
		response
	}];

	if (xrefResults
		&& response
		&& response.data
		&& response.data.items
		&& response.data.items.length > 0) {
		const newsItems = response.data.items;
		const xids = [];

		newsItems.forEach(item => {
			const { WSODIssue } = item;

			if (WSODIssue && WSODIssue.length > 0) {
				const issues = WSODIssue.split('|');

				if (issues && issues.length > 0) {
					issues.forEach(issue => {
						if (issue && issue !== '' && xids.indexOf(issue) === -1) {
							xids.push(issue);
						}
					});
				}
			}
		});

		if (xids.length > 0) {
			actions.push(requestXrefByVenueXids(xids));
		}
	}

	return actions;
};

const handleLoader = fetchName => {
	return ({
		type: Types.API_HANDLE_NEWS_LOADER,
		fetchName
	});
};

const requestMarketNews = (QBID, NewsInputs, onSuccess, xrefResults = false) => {
	const result = {
		type: Types.API_REQUEST_MARKET_NEWS,
		endPoint: `/news/v1/${QBID}/articles`,
		params: NewsInputs,
		ajaxType: 'POST',
		onSuccess: onSuccess || (response => { return receiveMarketNews(response, xrefResults); }),
		on404: receiveMarketNews,
		loader: handleLoader,
		fetchName: 'fetchingNewsData'
	};

	return result;
};

const requestEtfNews = (QBID, NewsInputs, xrefResults = false) => {
	const result = {
		type: Types.API_REQUEST_ETF_NEWS,
		endPoint: `/news/v1/${QBID}/articles`,
		params: NewsInputs,
		ajaxType: 'POST',
		onSuccess: response => { return receiveEtfNews(response, xrefResults); },
		on404: receiveEtfNews,
		loader: handleLoader,
		fetchName: 'fetchingEtfNewsData'
	};

	return result;
};

const requestNewsLink = (newsId, articleId, onSuccess) => {
	return ({
		type: Types.API_REQUEST_NEWS_LINK,
		endPoint: `/news/v1/${newsId}/articles/${articleId}`,
		params: {},
		ajaxType: 'GET',
		onSuccess: onSuccess || requestNewsArticle,
		loader: handleLoader,
		fetchName: 'fetchingNewsLink'
	});
};

const receiveNewsArticle = response => {
	return ({
		type: Types.API_RECEIVE_NEWS_ARTICLE,
		response
	});
};

const requestNewsArticle = (response, onSuccess) => {
	let href;
	let accept;

	if (response.data.links && response.data.links[0]) {
		href = response.data.links[0].href;
		accept = response.data.links[0].headerSchema.Accept;
	}

	return ({
		type: Types.API_REQUEST_NEWS_ARTICLE,
		endPoint: `/news${href}`,
		headers: {
			ACCEPT: accept
		},
		params: {},
		ajaxType: 'GET',
		onSuccess: onSuccess || receiveNewsArticle,
		loader: handleLoader,
		fetchName: 'fetchingNewsArticle'
	});
};

const getInsightsArgs = newsId => {
	switch (newsId) {
		case newsIdMap.usMorningNewsId:
			return {
				field: 'FeedID',
				conditions: [
					{
						operator: 'EqualTo',
						values: ['2229']
					}
				]
			};
		case newsIdMap.morningNewsId:
			return {
				field: 'FeedID',
				conditions: [
					{
						operator: 'EqualTo',
						values: ['2692']
					}
				]
			};
		case newsIdMap.weekAheadNewsId:
			return {
				field: 'Module',
				conditions: [
					{
						operator: 'EqualTo',
						values: ['CIBCWeekAhead']
					}
				]
			};
		default:
			return {};
	}
};

const requestInsights = (newsId, responseHandler) => {
	return ({
		type: Types.API_REQUEST_NEWS_INSIGHTS,
		endPoint: `/news/v1/${newsId === 3119 ? 3118 : newsId}/articles`,
		params: {
			argsOperator: 'AND',
			arguments: [getInsightsArgs(newsId)],
			sortArguments: [
				{
					direction: 'desc',
					field: 'DocumentDate'
				}
			],
			limit: 5,
			offset: 0
		},
		ajaxType: 'POST',
		onSuccess: responseHandler || (response => { return receiveInsights(response, newsId); }),
		on404: responseHandler || receiveInsights,
		loader: handleLoader,
		fetchName: 'fetchingNewsInsights'
	});
};

const receiveInsights = (response, newsId) => {
	return ({
		type: Types.API_RECEIVE_NEWS_INSIGHTS,
		response,
		newsId
	});
};

const requestPdf = (newsId, articleId) => {
	return ({
		type: Types.API_REQUEST_PDF,
		endPoint: `/news/v1/${parseInt(newsId, 10) === 3119 ? 3118 : newsId}/articles/${articleId}/component-type/PRES`,
		documentName: articleId,
		params: {},
		headers: {
			ACCEPT: 'application/pdf'
		},
		ajaxType: 'GETPDF',
		loader: handleLoader,
		fetchName: 'fetchingPdf'
	});
};

export {
	requestMarketNews,
	requestEtfNews,
	requestNewsArticle,
	requestNewsLink,
	requestInsights,
	receiveMarketNews,
	requestPdf,
	newsIdMap
};
